import { Howl } from 'howler'
import { shuffle } from './util'

const click = new Howl({
    src: ['/audio/soft-click.mp3'],
    html5: true,
    onplayerror: (e) => {
        console.log("play error",e);
        click.once('unlock', function() {
            click.play();
        });
    },
});

const ambient_tracks = [
    '/audio/sb_borealis.webm',
    '/audio/sb_petrichor.webm',
    '/audio/sb_filaments.webm',
    '/audio/sb_reverie.webm',
    '/audio/sb_sleep.webm',
    '/audio/sb_shemovedmountains.webm',
    '/audio/sb_solace.webm'
]

const synth_tracks = [
    '/audio/synthwave/sb_machina.webm',
    '/audio/synthwave/sb_tearsinrain.webm',
    '/audio/synthwave/sb_neon.webm',
    '/audio/synthwave/sb_twilightecho_nolead.webm'
]

let music_tracks = shuffle(ambient_tracks);
let current_genre = "ambient";

type Genre = "ambient" | "synthwave"


export function playClick() {
    click.play();
}

let music_track = null;
let music_track_idx = 0;
let music_enabled = false;

function playNextTrack() {
    music_track_idx++;
    music_track_idx = music_track_idx % music_tracks.length;
    music_track = new Howl({
        src: [ music_tracks[music_track_idx]],
        html5: true,
        volume: 0.5,
        onend: () => {
            if (music_enabled) {
                music_track.stop();
                playNextTrack();
            }
        },
        onplayerror: function() {
            music_track.once('unlock', function() {
                music_track.stop();
                music_track.play();
            });
        }
    })
    music_track.play();
}

export function changeGenre(genre:Genre) {
    if (current_genre == genre) return;
    setGenre(genre);
    if (music_enabled) {
        if (music_track) {
            music_track.stop();
        }
        playNextTrack();
    }
}

function setGenre(genre: Genre) {
    current_genre = genre;
    if (genre == "ambient") {
        music_tracks = shuffle(ambient_tracks);
    }

    if (genre == "synthwave") {
        music_tracks = shuffle(synth_tracks);
    }
}


export function startMusic(genre: Genre = null) {
    if (genre) {
        setGenre(genre);   
    }
    if (music_enabled) return;
    music_enabled = true;
    playNextTrack();
}


export function stopMusic() {
    music_enabled = false;
    if (music_track) {
        music_track.stop();
        music_track.unload();
    }
}